module.exports = __webpack_public_path__ + "static/media/icon_consumidor_final_active.b8d34b64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_consumidor_final_active.svg
// module id = 327
// module chunks = 0